import styled from 'styled-components';
import { BreadcrumbsStyled } from '../BreadcrumbsStyled';

export const BreadcrumbsDS = styled(BreadcrumbsStyled)`
    a {
        color: ${({ theme }) => theme.colors.red3};

        a:hover {
            color: ${({ theme }) => theme.colors.pink1};
        }
    }
    span {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }
    span,
    a {
        ::before {
            content: '>';
        }
    }
`;
